import React, { useEffect, useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import  { RestaurantContext } from "../../../../contexts/Restaurant"
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";
import ReportExcelPrintGap from "../../../components/Reports/ReportExcelPrintGap";


const CommisionReport = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
    setDataPaginating,
    generalSettings,
  } = useContext(SettingsContext);
  const { customerForSearch, getCustomer } = useContext(UserContext);
  const { branchForSearch, paymentTypeForSearch } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRefThermal = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [formData, setFormData] = useState({
    branch: null,
    payment: null,
  })
  const [generatedReport, setGeneratedReport] = useState(false);
  const [option, setOption] = useState("excel");
  const [reportOption,setReportOption] = useState("detail")

  let common_toast = {
    position: "bottom-center",
    closeButton: false,
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  const handleSetType = (e)=>{
    setReportOption(e.target.value)
  }

  const handleSetSelect = (key, value) => {
    setFormData({
      [key]: value
    });
  };

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `
        @page {
          margin: 15px 7px;
        }
      `,
  });

  //get excel reports filter
  const getExcelReport = () => {
    setReportData(null);
    setGeneratedReport(false);
    if (startDate !== null && endDate !== null) {
      getReport();
    } else {
      toast.error(
        `${_t(t("Please select from date, to date and group"))}`,
        common_toast
      );
    }
  };

  //get sale inv report
  const getReport = async () => {
    setDataPaginating(true);
    let fromDate = moment(startDate).format("YYYY-MM-DD");
    let toDate = moment(endDate).format("YYYY-MM-DD");
    const url = BASE_URL + "/settings/get-thirdparty-commission-report";
    let payload = new FormData();
    payload.append("type", reportOption);
    payload.append("from_date", fromDate);
    payload.append("to_date", toDate);
    payload.append("branch_id", formData.branch?.id ?? "");
    payload.append("payment_type_id", formData.payment?.id ?? "");

    return axios
      .post(url, payload, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setGeneratedReport(true);
        setReportData(res.data);
        setDataPaginating(false);
        if (option === "excel") {
          componentRef.current.handleDownload();
        } else {
          thermalPrint();
        }
      })
      .catch((error) => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, common_toast);
      });
  };

  const header = [
    { name: "S.No", render:(item,i)=> <>{i+1}</>},
    { name: "Date", render:(item)=> <Moment format="LL">{item.order_date}</Moment>},
    { name: "Document No", key: "document_no" },
    { name: "Payment Type", key: "payment_type" },
    { name: "Subtoal", key: "order_bill", total: 1},
    { name: "Tax Amount", key: "vat", total: 1},
    { name: "Payment Comission", key:"payment_type_comission"},
    { name: "Commission Amount", key:"commission_amount", total: 1},
    { name: "Delivery Charges", key:"service_charge" ,total: 1},
    { name: "Discount Amount", key:"discount_amount" ,total: 1},
    { name: "Total Amount", key:"total_payable" ,total: 1},
    { name: "Comission After Tax", key:"commission_after_tax" ,total: 1},
  ];

  const headerSummary = [
    { name: "S.No", render:(item,i)=> <>{i+1}</>},
    { name: "Date", render:(item)=> <Moment format="LL">{item.order_date}</Moment>},
    { name: "Payment Type", key: "name" },
    { name: "Subtotal", key: "order_amount", total: 1},
    { name: "Tax", key: "tax_amount", total: 1},
    { name: "Payment Comission", key:"payment_type_comission"},
    { name: "Commission Amount", key:"commission_amount", total: 1},
    { name: "Gross Amount After Comission", key:"gross_amount_after_comission", total: 1},
    { name: "Delivery Charges", key:"service_charge_amount" ,total: 1},
    { name: "Discount Amount", key:"discount_amount" ,total: 1},
    { name: "Total Amount", key:"total_bill" ,total: 1},
    { name: "Comission After Tax", key:"gross_amount_commission_after_tax" ,total: 1},
  ];

  return (
    <>
      <Helmet>
        <title>{_t(t("Commission Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename={reportOption === "summary" ? "Comission Summary Report" : "Comission Report"}
        sheet="sheet 1"
        buttonText="Commission Report"
        ref={componentRef}
      />

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating} />

                    {/* spin loading ends */}

                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Commission Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end">
                            <ReportTypeOptions
                              selectedOption={option}
                              onChange={handleOption}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={formData.branch}
                            classNamePrefix="select"
                            isClearable
                            className="table-text"
                            onChange={(branch)=>handleSetSelect("branch",branch)}
                            styles={customStyle}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>

                        <div className="col-2">
                          <Select
                            options={paymentTypeForSearch ? paymentTypeForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={formData.payment}
                            classNamePrefix="select"
                            isClearable
                            className="table-text"
                            onChange={(payment)=>handleSetSelect("payment",payment)}
                            styles={customStyle}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select payment type")) + "."}
                          />
                        </div>

                        <div className="col-2 mt-0">
                          <div className="mt-0 lg-text">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="detail"
                              name="detail"
                              value="detail"
                              onChange={(e) => handleSetType(e)}
                              checked={reportOption === "detail"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2"
                              htmlFor="detail"
                            >
                              {_t(t("Detail"))}
                            </label>
                          </div>
                          <div className="mt-1 lg-text">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="summary"
                              name="summary"
                              value="summary"
                              onChange={(e) => handleSetType(e)}
                              checked={reportOption === "summary"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2"
                              htmlFor="summary"
                            >
                              {_t(t("Summary"))}
                            </label>
                          </div>

                        </div>
                   
                        
                        <div className="col-2 t-mb-15 mb-md-0 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getExcelReport()}
                          >
                            GENERATE REPORT
                          </button>
                        </div>
                      </div>
                      <ReportExcelPrintGap
                        header={reportOption === "summary" ? headerSummary : header}
                        generatedReport = {generatedReport}
                        heading={reportOption === "summary" ? "Comission Summary Report" : "Comission Report"}
                        reportData={reportData}
                        startDate={startDate}
                        endDate={endDate}
                        componentRef={componentRef}
                        printRef={componentRefThermal}
                        branch={{
                          name: formData.branch?.name ?? "",
                          show: true,
                        }}
                        type = {option}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default CommisionReport;
